import { PRODUCT_MODE_MAP } from '@src/utils/constants';
import { getMetricShortName } from '@src/utils/metrics';

export const getMetricsMapping = () => {
  return {
    bufferingRatio: getMetricShortName({
      metricKey: 'RebufferingRatio',
      context: PRODUCT_MODE_MAP.EI,
    }),
    videoStartFailure: getMetricShortName({
      metricKey: 'VideoStartFailures',
      context: PRODUCT_MODE_MAP.EI,
    }),
    bitrateKbps: getMetricShortName({
      metricKey: 'Bitrate',
      context: PRODUCT_MODE_MAP.EI,
    }),
  };
};
